import { requestAssetApi } from './getAssetById';
import {
  ASSET_SEARCH_PAGE_SIZE,
  fetchDefaultBookableAssetListPage,
} from './assetSearchClient';

export { ASSET_SEARCH_PAGE_SIZE as BOOKABLE_ASSET_SEARCH_PAGE_SIZE } from './assetSearchClient';
export {
  buildSearchAssetsDto,
  fetchAllSearchAssetPages,
  fetchSearchAssetsForUiState,
  fetchSearchAssetsPage,
  hasClientSideBrowseFilters,
  hasFilterBeyondCountry,
  parseAssetSearchResponse,
  postSearchAssets,
  sanitizeSearchAssetsWireBody,
} from './assetSearchClient';
export type {
  AssetSearchResult,
  AssetSearchSort,
  AssetSearchUiState,
  SearchAssetsDto,
} from './assetSearchClient';

/** @deprecated Use {@link buildSearchAssetsDto} / {@link fetchSearchAssetsForUiState}. */
export function buildBookableAssetSearchBody(): Record<string, unknown> {
  return {
    fuzzy: true,
    filters: {
      asset_status: ['active'],
      min_capacity: 0,
    },
    pagination: {
      from: 0,
      size: ASSET_SEARCH_PAGE_SIZE,
    },
  };
}

/** Client browse — first page via `POST /search/assets` (list mode). */
export async function searchBookableAssets(): Promise<unknown> {
  const page = await fetchDefaultBookableAssetListPage(0);
  return page.records;
}

export async function fetchActiveAssetsListing(forClientBrowse: boolean): Promise<unknown> {
  if (forClientBrowse) {
    return searchBookableAssets();
  }
  return requestAssetApi({ method: 'GET', path: '/assets/activeassets' });
}

export async function fetchMyAssetsListing(): Promise<unknown> {
  return requestAssetApi({ method: 'GET', path: '/assets' });
}
